import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { bethlehemConfig } from "./data";

export default function BethlehemPage() {
  return <CityPageTemplate config={bethlehemConfig} />;
}